export default __webpack_public_path__ + "static/media/animatecard1.27ccf129.jpg";